import React, { useEffect, useState, createContext, useContext } from 'react';
type Theme = 'light' | 'dark';
interface AdminThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
}
const AdminThemeContext = createContext<AdminThemeContextType | undefined>(undefined);
export const AdminThemeProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [theme, setTheme] = useState<Theme>(() => {
    const saved = localStorage.getItem('amu-admin-theme');
    return saved as Theme || 'dark';
  });
  useEffect(() => {
    localStorage.setItem('amu-admin-theme', theme);
  }, [theme]);
  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };
  return <AdminThemeContext.Provider value={{
    theme,
    toggleTheme
  }} data-id="element-334">
      <div className={`admin-theme-root ${theme === 'dark' ? 'dark' : ''} min-h-screen bg-slate-50 dark:bg-[#0f172a] transition-colors duration-200`} data-id="element-335">
        {children}
      </div>
    </AdminThemeContext.Provider>;
};
export const useAdminTheme = () => {
  const context = useContext(AdminThemeContext);
  if (context === undefined) {
    throw new Error('useAdminTheme must be used within an AdminThemeProvider');
  }
  return context;
};